import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonHeader } from '@ionic/react'
import './index.scss'

interface IProps {
  title: string;
  onClose?: () => void;
}

const ModalHeader: FC<IProps> = (props: IProps) => {
  const { title, onClose } = props
  return (
    <IonHeader className='mkt-modal-header'>
      <span>{title}</span>
      {onClose && <div data-cypid='mtkModalHeaderClose' onClick={onClose}><i className='iconfont icon-close'></i></div>}
    </IonHeader>
  )
}

export default observer(ModalHeader)
